import React, { memo, useCallback, useMemo } from "react";
import { useMediaQuery } from "react-responsive";

const totalSuggestions = 4;

const suggestionsList = [
  "SAEP offre servizi di Business Intelligence?",
  "Parlami della migrazione ACG nel vostro ambito.",
  "Quali vantaggi porta avere un unico software integrato?",
  "Qual è il valore aggiunto di adottare l'ERP SAEP?",
  "Qual è il valore aggiunto di adottare l'ERP SAEP?",
];

const getRandomItems = (array, count) => {
  const shuffled = [...array].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

/**
 * A functional React component to display a list of suggestions.
 * Each suggestion can be clicked to send a predefined message.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.sendMessage - Function to send a message with type and content.
 * @returns {JSX.Element} Rendered Suggestions component.
 */
const Suggestions = ({ sendMessage }) => {
  const isSmall = useMediaQuery({ query: `(max-width: 1024px)` });

  // Memoize the selection of random suggestions to ensure consistency during renders
  const selectedSuggestions = useMemo(
    () => getRandomItems(suggestionsList, totalSuggestions),
    []
  );

  // Divide selected suggestions into always visible and conditional
  const alwaysVisibleSuggestions = selectedSuggestions.slice(0, 2);
  const conditionalSuggestions = selectedSuggestions.slice(2, totalSuggestions);

  const sendSuggestionMessage = useCallback(
    (e) => {
      const message = e.target.innerText.trim();
      if (!message) return;
      sendMessage("click", message);
    },
    [sendMessage]
  );

  const Suggestion = memo(({ text }) => {
    return (
      <div onClick={sendSuggestionMessage} className="suggestionsItem">
        {text}
      </div>
    );
  });

  return (
    <div className="suggestionsCont">
      {alwaysVisibleSuggestions.map((text, index) => (
        <Suggestion key={`always-${index}`} text={text} />
      ))}

      {!isSmall &&
        conditionalSuggestions.map((text, index) => (
          <Suggestion key={`conditional-${index}`} text={text} />
        ))}
    </div>
  );
};

export default Suggestions;
